import * as THREE from 'three';
import { Entity } from './Entity.js';

/**
 * @typedef {Object} PoopOptions
 * @property {THREE.Vector3} [position] - Initial position
 */

/**
 * A poop entity. Left behind by the cat as evidence of their crimes.
 */
export class Poop extends Entity {
    /**
     * @param {PoopOptions} [options]
     */
    constructor(options = {}) {
        super({
            position: options.position,
            collisionRadius: 0,
            collidable: false,
        });

        this.#buildMesh();
    }

    /**
     * Build the poop mesh (simple brown sphere)
     */
    #buildMesh() {
        const poopGeometry = new THREE.SphereGeometry(0.2, 8, 8);
        const poopMaterial = new THREE.MeshStandardMaterial({ color: 0x4B3621 });
        const poop = new THREE.Mesh(poopGeometry, poopMaterial);
        poop.castShadow = true;
        poop.receiveShadow = true;
        this.mesh.add(poop);
    }
}
